import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ExerciseModel } from '../../../models/exercise.model';
import { GroupModel } from '../../../models/group.model';
import { AcModel } from '../../../models/ac.model';
import { Subscription } from 'rxjs';
import { DataService } from '../../../services/data.service';
import { SlotModel } from '../../../models/slot.model';
import { AuthStateService } from '../../../services/auth-state.service';
import { CandidateModel } from '../../../models/candidate.model';

@Component({
  selector: 'app-content-controls',
  templateUrl: './content-controls.component.html',
  styleUrls: ['./content-controls.component.scss']
})
export class ContentControlsComponent implements OnInit, OnDestroy {

  @Input() exercise: ExerciseModel = null;
  @Input() group: GroupModel = null;
  @Input() candidate: CandidateModel = null;

  public ac: AcModel = null;
  public acSubscription: Subscription = null;
  public slots: Array<SlotModel> = [];

  constructor(
    public data: DataService,
    public auth: AuthStateService,
  ) { }

  ngOnInit(): void {
    this.acSubscription = this.data.ac$.subscribe({
      next: (ac: AcModel) => {
        if (ac !== null) {
          this.ac = ac;
          this.slots = this.ac.slots.filter(slot => slot.exercise_id === this.exercise?.id);
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.acSubscription !== null) {
      this.acSubscription.unsubscribe();
      this.acSubscription = null;
    }
  }

}
